import { NbToastrService } from '@nebular/theme';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { APIService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class CandidatesService extends APIService {
  candidate: any = null;
  assestments: any = {
    data: null,
    id: -1,
  };
  constructor(private toastrService: NbToastrService,http: HttpClient, router: Router) {
    super(http)
    this.endPoint = "candidates"
    this.candidate = {}
  }

  async getCandidate(id) {
    if (!this.candidate || this.candidate?.id != id)
      await this.http
        .get(this.url + `/${id}`, this.httpOptions)
        .toPromise()
        .then((res) => {
          this.candidate = res['data']
        });
    return this.candidate;
  }
  put_is_hiered(id) {
    return this.http.put(this.url + `/is_hiered/` + `${id}`, this.httpOptions)
  }

  put_in_process(id) {
    return this.http.put(this.url + `/is_in_process/` + `${id}`, this.httpOptions)
  }
  put_is_not_qualified(id){
    return this.http.put(this.url + `/is_not_qualified/`+`${id}`,this.httpOptions)
  }

  resete_state(id){
    return this.http.put(this.url + `/resete_state/`+`${id}`,this.httpOptions)
  }


  // retention(id){
  //   return this.http.put(this.url + `/retention/`+`${id}`,this.httpOptions)
  // }


  
  getAll(skip = 0, limit = 10, searchParams = null, isFile = false) {
    type ValueType = {
      start?: Date;
      end?: Date;
      // include other properties as needed
    };
    
    // then, when you have a 'value' of this type:
    

    let arrayOfSearch = [];
    if (searchParams != null)
      for (const [key, value] of Object.entries(searchParams)) {
        if (value != null && value != '')
          if (key == 'gender' || key == 'address_city_id' || key == "military_service" || key == "is_albaraka_emp" || key == "vacancies_id" || key == "maritial_status")
            arrayOfSearch.push(key + "=0," + value);
          else if (key == 'date_range' || key == 'last_update_range' || key == 'interview_date_range') {
            //@ts-ignore
            // const d1 = value.start?.getDate() + "-" + (value.start?.getMonth() + 1) + "-" + value.start?.getFullYear();
            // //@ts-ignore
            // const d2 = value.end?.getDate() + "-" + (value.end?.getMonth() + 1) + "-" + value.end?.getFullYear();
            const dateValue = value as ValueType;

            const d1 = formatDateToLocalISO(dateValue.start);
            const d2 = formatDateToLocalISO(dateValue.end);
            
            function formatDateToLocalISO(date: Date | undefined): string | undefined {
                if (!date) {
                    return undefined;
                }
                let month = '' + (date.getMonth() + 1);
                let day = '' + date.getDate();
                const year = date.getFullYear();
            
                if (month.length < 2) {
                    month = '0' + month;
                }
                if (day.length < 2) {
                    day = '0' + day;
                }
            
                return [year, month, day].join('-');
            }
            

            //@ts-ignore
            if (value.end)
              arrayOfSearch.push(key + "=" + d1 + "," + d2);
            else
              arrayOfSearch.push(key + "=" + d1 + "," + d1);
          }
          else if (key == 'duties') {
            //@ts-ignore
            if (Array.from(value).length > 0)
              //@ts-ignore
              arrayOfSearch.push("duties=" + Array.from(value).join(','));
          }
          else if (key == 'professional_certificate_name') {
            //@ts-ignore
            if (Array.from(value).length > 0)
              //@ts-ignore
              arrayOfSearch.push("professional_certificate_name=" + Array.from(value).join(','));
          }
          else if (key == 'notes') {
            //@ts-ignore
            if (Array.from(value).length > 0)
              //@ts-ignore
              arrayOfSearch.push("notes=" + Array.from(value).join(','));
          }
          else
            arrayOfSearch.push(key + "=" + value);
      }
    var httpOptions = { ...this.httpOptions };
    if (isFile) {
      httpOptions['responseType'] = 'blob';
      httpOptions.headers.set('Content-Type', 'blob');
    }
    return this.http.get(this.url + `?skip=${skip}&limit=${limit}&` + arrayOfSearch.join('&'), httpOptions)
  }

  addNote(notes) {
    return this.http.post(this.url + `/notes`, notes, this.httpOptions);
  }

  deleteNote(note_id) {
    return this.http.delete(this.url + `/notes/` + note_id, this.httpOptions);
  }

  getNotes(candidate_id) {
    return this.http.get(this.url + `/notes/` + candidate_id, this.httpOptions);
  }

  getInterviews(candidate_id) {
    return this.http.get(this.url + `/interviews/` + candidate_id, this.httpOptions);
  }

  addInterview(interviews) {
    return this.http.post(this.url + `/interviews`, interviews, this.httpOptions);
  }

  deleteInterview(interview_id) {
    return this.http.delete(this.url + `/interviews/` + interview_id, this.httpOptions);
  }

  attendInterview(interview_id, status) {
    return this.http.put(this.url + `/interviews/` + interview_id + `?status=` + status, this.httpOptions);
  }

  uploadImage(image) {
    return this.http.post(this.url + `/uploading-doc`, image);
  }

  deleteImage(image_id) {
    return this.http.delete(this.url + `/uploading-doc?id=` + image_id, this.httpOptions);
  }

  addVacancies(candidateId, vacancyId) {
    console.warn(candidateId + '' + vacancyId)
    return this.http.post(this.url + '/' + candidateId + '/vacancies', { v_id: vacancyId }, this.httpOptions)
  }

  add_evaluation(candidateId, data) {
    return this.http.post(
      this.url + "/" + candidateId + "/evaluation",
      data,
      this.httpOptions
    );
  }

  add_evaluation2(candidateId, data) {
    return this.http.post(
      this.url + "/" + candidateId + "/evaluation2",
      data,
      this.httpOptions
    );
  }

  update_evaluation(candidateId, data) {
    return this.http.put(
      this.url + "/" + candidateId + "/evaluation",
      data,
      this.httpOptions
    );
  }

  update_evaluation2(candidateId, data) {
    return this.http.put(
      this.url + "/" + candidateId + "/evaluation2",
      data,
      this.httpOptions
    );
  }

  async get_assessments(candidateId) {
    if (!this.assestments.data || this.assestments.id != candidateId)
      await this.http
        .get(this.url + "/" + candidateId + "/evaluation", this.httpOptions)
        .toPromise()
        .then((res) => {
          this.assestments.data = res;
        });
    this.assestments.id = candidateId;
    return this.assestments.data;
  }

}
